module.exports = "/images/bg_nickname.jpg";